import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';

export function useDirectSaleItemPermissions() {
  return {
    editDiscountValue: hasPermissions([
      Authorities.MOVIMENTATION_SALE_ITEM_EDIT_DISCOUNT_VALUE,
    ]),
    addDiscountGreaterDefinedByCompany: hasPermissions([
      Authorities.MOVIMENTATION_SALE_ADD_DISCOUNT_PERCENTAGE_GREATER_THAN_DEFINED_BY_THE_COMPANY,
    ]),
    giveDiscountOverLimit: hasPermissions([
      Authorities.MOVIMENTATION_SALE_GIVE_DISCOUNT_OVER_LIMIT,
    ]),
    makeSaleAboveCreditLimit: hasPermissions([
      Authorities.MOVIMENTATION_SALE_MAKE_SALE_ABOVE_CREDIT_LIMIT,
    ]),
    editValueDirectSale: hasPermissions([
      Authorities.MOVIMENTATION_SALE_ITEM_EDITE_SALE_VALUE,
    ]),
  };
}
